import { IconProp } from "@fortawesome/fontawesome-svg-core";
import {
  faAddressBook,
  faAlignLeft,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faBars,
  faBookOpen,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faClock,
  faClone,
  faDownload,
  faEarthAfrica,
  faEye,
  faEyeSlash,
  faFile,
  faFolderOpen,
  faForward,
  faForwardStep,
  faGrip,
  faHatWizard,
  faKeyboard,
  faLaptopCode,
  faLink,
  faLinkSlash,
  faLock,
  faMagnifyingGlassLocation,
  faMaximize,
  faMinimize,
  faPause,
  faPenToSquare,
  faPlay,
  faPlus,
  faQuestion,
  faRedo,
  faStepForward,
  faStop,
  faSync,
  faTerminal,
  faTrashCan,
  faUpload,
  faFileLines,
  faBugs
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";

import "./icons.less";

export const faIcons = {
  play: faPlay,
  pause: faPause,
  stop: faStop,
  redo: faRedo,
  check: faCheck,
  clock: faClock,
  clone: faClone,
  edit: faPenToSquare,
  file: faFile,
  folderOpen: faFolderOpen,
  download: faDownload,
  upload: faUpload,
  link: faLink,
  unlink: faLinkSlash,
  plus: faPlus,
  forward: faForward,
  terminal: faTerminal,
  keyboard: faKeyboard,
  bookOpen: faBookOpen,
  question: faQuestion,
  stepForward: faStepForward,
  bars: faBars,
  listBrowsing: faBars, // This is used for list browsing.
  gridBrowsing: faGrip, // This is used for tile browsing.
  addressBook: faAddressBook,
  alignLeft: faAlignLeft,
  magnifyingGlassLocation: faMagnifyingGlassLocation,
  sync: faSync,
  arrowDown: faArrowDown,
  arrowRight: faArrowRight,
  arrowLeft: faArrowLeft,
  arrowUp: faArrowUp,
  chevronUp: faChevronUp,
  trash: faTrashCan,
  developer: faLaptopCode,
  lock: faLock,
  wizardHat: faHatWizard,
  earthAfrica: faEarthAfrica,
  forwardStep: faForwardStep,
  minimize: faMinimize,
  maximize: faMaximize,
  visible: faEye,
  hidden: faEyeSlash,
  chevronDown: faChevronDown,
  chevronLeft: faChevronLeft,
  chevronRight: faChevronRight,
  fileLines: faFileLines,
  bugs: faBugs,
};

export const cssIcons = {
  addTab: "icon-add-tab",
  bag: "icon-bag",
  bookanes: "icon-bookends",
  closeWindow: "icon-close-window",
  console: "icon-console",
  cursor: "icon-cursor",
  diamond: "icon-diamond",
  docsScreenArrowLeft: "icon-docs-screen-arrow-left",
  docsScreenArrowRight: "icon-docs-screen-arrow-right",
  docsScreenIcon01: "icon-docs-screen-icon-01",
  docsScreenIcon02: "icon-docs-screen-icon-02",
  docsScreenIcon03: "icon-docs-screen-icon-03",
  docsScreenProgressSlider01: "icon-docs-screen-progress-slider-01",
  docsScreenProgressSlider02: "icon-docs-screen-progress-slider-02",
  docsScreenTabIcon01: "icon-docs-screen-tab-icon-01",
  docsScreenTabIcon02: "icon-docs-screen-tab-icon-02",
  docsScreenTabIcon03: "icon-docs-screen-tab-icon-03",
  docs: "icon-docs",
  editor: "icon-editor",
  exclamation: "icon-exclamation",
  format: "icon-format",
  gameLogo: "game-logo",
  insightSymbol: "icon-insight-symbol",
  inventory: "icon-inventory",
  load: "icon-load",
  map: "icon-map",
  new: "icon-new",
  quest: "icon-quest",
  run: "icon-run",
  save: "icon-save",
  settings: "icon-settings",
  skillFire: "icon-skill-fire",
  skillGravity: "icon-skill-gravity",
  skillIce: "icon-skill-ice",
  skillTree: "icon-skill-tree",
  speed: "icon-speed",
  spellDeck1: "icon-spell-deck-screen-01",
  spellDeskCurrency: "icon-spell-deck-screen-02-currency",
  spellDeck: "icon-spell-deck",
  tome: "icon-tome",
  mlcCodeEditor: "mlc-icon-code-editor",
  mlcDocs: "mlc-icon-docs",
  mlcInventory: "mlc-icon-inventory",
  mlcSettings: "mlc-icon-settings",
  mlcScript: "mlc-icon-script",
  mlcDice: "mlc-icon-dice",
  player: "icon-player",
  bagcloth: "icon-bag-cloth",
  key: "icon-key",
  potion: "icon-potion",
  wolf: "icon-wolf",
  sword: "icon-sword",
  armor: "icon-armor",
  miscItem: "icon-misc-item",
  triangleUp: "icon-triangle-up",
  triangleDown: "icon-triangle-down",
};

export const newCssIcons = {
  addTabFilled: "add-tab-fill",
  addTabStroked: "add-tab-stroke",
  addressBookFilled: "address-book-fill",
  addressBookStroked: "address-book-stroke",
  air: "air",
  alignLeftFilled: "align-left-fill",
  alignLeftStroked: "align-left-stroke",
  arrowDownFilled: "arrow-down-fill",
  arrowDownStroked: "arrow-down-stroke",
  arrowLeftFilled: "arrow-left-fill",
  arrowLeftStroked: "arrow-left-stroke",
  arrowPlayFilled: "arrow-play-fill",
  arrowPlayStroked: "arrow-play-stroke",
  arrowRightFilled: "arrow-right-fill",
  arrowRightStroked: "arrow-right-stroke",
  arrowStopFilled: "arrow-stop-fill",
  arrowStopStroked: "arrow-stop-stroke",
  arrowUpFilled: "arrow-up-fill",
  arrowUpStroked: "arrow-up-stroke",
  blockFilled: "block-fill",
  blockInBlock: "block-in-block",
  bookFilled: "book-fill",
  bookHalfFilled: "book-half-fill",
  bookStroked: "book-stroke",
  bugFilled: "bug-fill",
  bugStroked: "bug-stroke",
  checkFilled: "check-fill",
  checkStroked: "check-stroke",
  chevronUpFilled: "chevron-up-fill",
  chevronUpStroked: "chevron-up-stroke",
  clockFilled: "clock-fill",
  clockStroked: "clock-stroke",
  closeFilled: "close-fill",
  closeStroked: "close-stroke",
  codingFilled: "coding-fill",
  codingStroked: "coding-stroke",
  control: "control",
  currencyA: "currency-a",
  currencyB: "currency-b",
  currencyC: "currency-c",
  currencyD: "currency-d",
  doubleArrowFilled: "double-arrow-fill",
  doubleArrowStroked: "double-arrow-stroke",
  exclamationFilled: "exclamation-fill",
  exclamationStroked: "exclamation-stroke",
  fileFilled: "file-fill",
  fileStroked: "file-stroke",
  globeFilled: "globe-fill",
  globeStroked: "globe-stroke",
  gridFilled: "grid-fill",
  gridStroked: "grid-stroke",
  healing: "healing",
  ice: "ice",
  inventoryFilled: "inventory-fill",
  inventoryStroked: "inventory-stroke",
  keyboardFilled: "keyboard-fill",
  keyboardStroked: "keyboard-stroke",
  levelSelectFilled: "level-select-fill",
  levelSelectStroked: "level-select-stroke",
  lightning: "lightning",
  listViewFilled: "list-view-fill",
  listViewStroked: "list-view-stroke",
  loadSpellFilled: "load-spell-fill",
  loadSpellStroked: "load-spell-stroke",
  locationSearchFilled: "location-search-fill",
  locationSearchStroked: "location-search-stroke",
  newSpellPageFilled: "new-spell-page-fill",
  newSpellPageStroked: "new-spell-page-stroke",
  pauseFilled: "pause-fill",
  pauseStroked: "pause-stroke",
  penFilled: "pen-fill",
  penStroked: "pen-stroke",
  questionFilled: "question-fill",
  questionStroked: "question-stroke",
  redoFilled: "redo-fill",
  redoStroked: "redo-stroke",
  saveSpellFilled: "save-spell-fill",
  saveSpellStroked: "save-spell-stroke",
  searchFilled: "search-fill",
  searchStroked: "search-stroke",
  settingsFilled: "settings-fill",
  settingsStroked: "settings-stroke",
  skillsFilled: "skills-fill",
  skillsStroked: "skills-stroke",
  speedFilled: "speed-fill",
  speedStroked: "speed-stroke",
  stone: "stone",
  syncFilled: "sync-fill",
  syncStroked: "sync-stroke",
  terminalFilled: "terminal-fill",
  terminalStroked: "terminal-stroke",
  trashFilled: "trash-fill",
  trashStroked: "trash-stroke",
  water: "water"
};

export type IconName =
  | keyof typeof faIcons
  | keyof typeof cssIcons
  | keyof typeof newCssIcons;

export function isSupportedIcon(name: string): name is IconName {
  return name in faIcons || name in cssIcons || name in newCssIcons;
}

export type IconProps = {
  icon: IconName;
  className?: string;
  size?: "font" | "fill";
};

const faIconsRecord = faIcons as Record<string, IconProp>;
const cssIconsRecord = cssIcons as Record<string, string>;
const newCssIconsRecord = newCssIcons as Record<string, string>;

export function Icon(props: IconProps) {
  const { icon, size = "fill", className: classNameIn } = props;
  const className = cx(
    classNameIn,
    size === "fill" && "icon-size-fill",
    size === "font" && "icon-size-font"
  );
  if (faIconsRecord[icon] !== undefined) {
    return <FontAwesomeIcon className={className} icon={faIconsRecord[icon]} />;
  }
  return (
    <span
      className={`${className} svg-icon ${cssIconsRecord[icon] ?? newCssIconsRecord[icon]}`}
    />
  );
}
